module.exports = __webpack_public_path__ + "media/images/undraw_hire-c538652fe3aa24d2a7f0ff6393ac2bf8.svg";